import Api from "@/services/Api";

export default {
  postSubmitAlbum(album_id) {
    return Api.post(`/album/${album_id}/submit`);
  },
  postFetchCoverArt(query) {
    return Api.post(process.env.VUE_APP_IMAGE_SERVICE_URL, {
      query
    });
  },
  createAlbum(params) {
    return Api.post(`/album`, params);
  },
  postArchiveAlbum(albumId) {
    return Api.post(`/release/archive/${albumId}`);
  },
  updateAlbum(id, params) {
    return Api.put(`/album/${id}`, params);
  },
  postAddAlbumSongs(album_id, songIds) {
    return Api.post(`/album/${album_id}/songs`, { songIds });
  },
  updateAlbumSongs(album_id, songs) {
    return Api.patch(`/release/${album_id}/songs`, { songs: songs });
  },
  putAddAlbumSongs(album_id, songs) {
    return Api.put(`/release/${album_id}/songs`, { songs: songs });
  },
  getUserAlbums(params) {
    return Api.get(`/user/albums`, {
      params: {
        query: params.query ? params.query : null,
        sort: params.sort ? params.sort : null,
        page: params.page ? params.page : 1,
        perPage: params.perPage ? params.perPage : 20
      }
    });
  },
  getReleases() {
    return Api.get("/featured/releases/active");
  },
  getAlbumInfo(album_id) {
    return Api.get(`/album/${album_id}`);
  },
  getAlbumTracks(album_id) {
    return Api.get(`/album/${album_id}/tracks`);
  },
  getAlbumSongs(album_id) {
    return Api.get(`/album/${album_id}/songs`);
  },
  getAlbumStreams(album_id, start_date, end_date) {
    return Api.get(
      `/album/${album_id}/stats?start_date=${start_date}&end_date=${end_date}`
    );
  },
  getUserStreams() {
    return Api.get(`/user/total_streams`);
  },
  getArtistExists(query) {
    return Api.get("/dg/artist_exists?search=" + query);
  }
};
